import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import { styled } from '@mui/material/styles';

const Accordion = styled(MuiAccordion)(({ theme }) => ({
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
        borderBottom: 0
    },
    '&:before': {
        display: 'none'
    },
    '&.Mui-expanded': {
        margin: 'auto'
    }
}));

const AccordionSummary = styled(MuiAccordionSummary)(({ theme }) => ({
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&.Mui-expanded': {
        minHeight: 56
    },
    '& .MuiAccordionSummary-content.Mui-expanded': {
        margin: '12px 0'
    }
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: 0
}));

export { Accordion, AccordionDetails, AccordionSummary };
